module.exports = __webpack_public_path__ + "img/set-transfer.213e25ec.png";